import React, { useState, useEffect } from 'react';

export default function Countdown({ targetDate, eventTitle = "ØrBike 2026" }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isPassed, setIsPassed] = useState(false);

  function calculateTimeLeft() {
    if (!targetDate) return null;

    // targetDate kan være YYYY-MM-DD f.eks. "2026-11-14"
    const target = new Date(targetDate);
    // Sæt starttidspunkt til f.eks. kl 09:00 på dagen
    target.setHours(9, 0, 0, 0);

    const now = new Date();
    const difference = target.getTime() - now.getTime();

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, difference: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      difference
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining = calculateTimeLeft();
      if (!remaining || remaining.difference <= 0) {
        setIsPassed(true);
        clearInterval(timer);
      } else {
        setIsPassed(false);
        setTimeLeft(remaining);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (isPassed) {
    return (
      <div className="bg-gradient-to-r from-pink-900/30 via-purple-900/30 to-slate-900/50 border border-pink-500/30 rounded-2xl p-6 sm:p-8 text-center max-w-2xl mx-auto shadow-[0_0_30px_rgba(255,42,141,0.2)]">
        <span className="inline-block px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-300 border border-pink-500/40 mb-3">
          Eventstatus
        </span>
        <h3 className="text-2xl sm:text-3xl font-extrabold text-white font-display uppercase tracking-wide">
          Tak for et fantastisk ØrBike!
        </h3>
        <p className="text-slate-300 text-sm mt-2">
          Hold øje med vores sociale medier og denne side – billetsalget til næste event åbner snart.
        </p>
      </div>
    );
  }

  if (!timeLeft) {
    return null;
  }

  const timeBlocks = [
    { label: "Dage", value: String(timeLeft.days).padStart(2, '0') },
    { label: "Timer", value: String(timeLeft.hours).padStart(2, '0') },
    { label: "Minutter", value: String(timeLeft.minutes).padStart(2, '0') },
    { label: "Sekunder", value: String(timeLeft.seconds).padStart(2, '0') },
  ];

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="flex items-center justify-center gap-2 mb-3">
        <span className="w-2 h-2 rounded-full bg-pink-500 animate-pulse"></span>
        <span className="text-xs uppercase tracking-widest font-bold text-pink-400 font-mono">
          Nedttælling til {eventTitle}
        </span>
      </div>

      <div className="grid grid-cols-4 gap-2 sm:gap-4 text-center">
        {timeBlocks.map((block, i) => (
          <div
            key={i}
            className="bg-[#12141f]/90 border border-pink-500/25 rounded-xl sm:rounded-2xl p-3 sm:p-5 backdrop-blur-md shadow-[0_0_20px_rgba(255,42,141,0.15)] relative overflow-hidden group hover:border-pink-500/60 transition-colors"
          >
            <div className="text-3xl sm:text-5xl md:text-6xl font-black font-display text-white tracking-tight leading-none group-hover:text-pink-300 transition-colors">
              {block.value}
            </div>
            <div className="text-[10px] sm:text-xs uppercase tracking-wider font-semibold text-slate-400 mt-1 sm:mt-2">
              {block.label}
            </div>
            <div className="absolute top-0 inset-x-0 h-0.5 bg-gradient-to-r from-pink-500 to-purple-500 opacity-70"></div>
          </div>
        ))}
      </div>
    </div>
  );
}
